import { render, staticRenderFns } from "./ProductListComponent.vue?vue&type=template&id=39382ad8&scoped=true&"
import script from "./ProductListComponent.vue?vue&type=script&lang=js&"
export * from "./ProductListComponent.vue?vue&type=script&lang=js&"
import style0 from "./ProductListComponent.vue?vue&type=style&index=0&id=39382ad8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39382ad8",
  null
  
)

export default component.exports